export type Locale = 'de' | 'en' | 'zh-CN'
export const defaultLocale: Locale = 'en'
export const locales: Locale[] = ['en', 'de', 'zh-CN']

export interface Translations {
  common: {
    navigation: {
      home: string
      about: string
      solutions: string
      contact: string
      blog: string
      legal: string
      privacy: string
    }
    buttons: {
      learnMore: string
      getStarted: string
      contactUs: string
    }
  }
  pages: {
    home: {
      hero: {
        title: string[]
        subtitle: string
        cta: {
          getStarted: string
          readMore: string
        }
      }
      features: {
        title: string
        subtitle: string
        items: Array<{
          title: string
          content: string
        }>
      }
      problem: {
        title: string
        subtitle: string
        problems: Array<{
          title: string
          description: string
        }>
      }
      solution: {
        title: string
        subtitle: string
        description: string
        files: Array<{
          name: string
          body: string
        }>
        features: Array<{
          name: string
          description: string
        }>
      }
      "how-it-works": {
        title: string
        subtitle: string
        steps: Array<{
          id: number
          title: string
          content: string
        }>
      }
      faq: {
        title: string
        subtitle: string
        items: Array<{
          question: string
          answer: string
        }>
      }
      cta: {
        title: string
        description: string
      }
    }
    about: {
      hero: {
        title: string
        subtitle: string
      }
      vision: {
        title: string
        description: string
      }
      mission: {
        title: string
        description: string
      }
    }
    contact: {
      title: string
      description: string
      form: {
        schedule: {
          title: string
          button: string
        }
        firstName: string
        lastName: string
        email: string
        phone: string
        subject: {
          label: string
          placeholder: string
          options: {
            general: string
            support: string
            business: string
            other: string
          }
        }
        message: {
          label: string
          placeholder: string
        }
        submit: string
        sending: string
        success: string
        error: string
      }
    }
  }
}

export function getLocaleFromPathname(pathname: string): Locale {
  if (pathname.startsWith('/de')) return 'de'
  if (pathname.startsWith('/zh-CN') || pathname.startsWith('/zh')) return 'zh-CN'
  return 'en'
}
